import { IUploadAttachmentResponse, UploadAttachmentParams, IConversationRepository } from "@/core/repositories/conversation";

export class UploadConversationAttachmentUseCase {
  constructor(private readonly conversationRepository: IConversationRepository) {}

  async execute(params: UploadAttachmentParams): Promise<IUploadAttachmentResponse> {
    return this.conversationRepository.uploadAttachment(params);
  }
}
